import { FormattedMessage } from 'react-intl';
import ImageWithFallback from '@liveauctioneers/caterwaul-components/lib/ImageWithFallback/ImageWithFallback2';
import React from 'react';
import styles from './Trust.module.scss';
import TrustBoxWidget from '@/components/TrustBox/TrustBoxWidget';

const Trust = () => {
    return (
        <div className={styles.trust}>
            <div className={styles.trustContainer}>
                <div className={styles.affiliates}>
                    <div className={styles.title}>
                        <FormattedMessage id="as_seen_on" />
                    </div>
                    <div className={styles.affiliateContent}>
                        <div className={styles.nbc}>
                            <ImageWithFallback
                                alt="NBC"
                                src="https://p1.liveauctioneers.com/dist/images/NBC.svg"
                                style={{ maxHeight: '43px', maxWidth: '44px' }}
                            />
                        </div>
                        <div className={styles.abc}>
                            <ImageWithFallback
                                alt="ABC"
                                src="https://p1.liveauctioneers.com/dist/images/ABC.svg"
                                style={{ maxHeight: '38px', maxWidth: '38px' }}
                            />
                        </div>
                        <div className={styles.today}>
                            <ImageWithFallback
                                alt="Today"
                                src="https://p1.liveauctioneers.com/dist/images/TODAY.svg"
                                style={{ maxHeight: '42px', maxWidth: '57px' }}
                            />
                        </div>
                        <div className={styles['chicago-tribune']}>
                            <ImageWithFallback
                                alt="Chicago Tribune"
                                src="https://p1.liveauctioneers.com/dist/images/ChicagoTribune.svg"
                                style={{ maxHeight: '20px', maxWidth: '137px' }}
                            />
                        </div>
                        <div className={styles['architectural-digest']}>
                            <ImageWithFallback
                                alt="Architectural Digest"
                                src="https://p1.liveauctioneers.com/dist/images/ArchDigest.svg"
                                style={{ maxHeight: '14px', maxWidth: '162px' }}
                            />
                        </div>
                    </div>
                </div>
                <div className={styles.separator} />
                <div className={styles.confidence}>
                    <div className={styles.title}>
                        <FormattedMessage id="shop_with_confidence" />
                    </div>
                    <div className={styles.trustContent}>
                        <FormattedMessage id="since_2002_liveauctioneers_has_made_items" />
                    </div>
                    <div className={styles.trustContent}>
                        <TrustBoxWidget className={styles.trustBox} />
                        <a
                            href="http://www.bbb.org/new-york-city/business-reviews/internet-auction-service/live-auctioneers-llc-in-new-york-ny-123530/#bbbonlineclick"
                            rel="nofollow noopener"
                            target="_blank"
                        >
                            <ImageWithFallback
                                alt="LiveAuctioneers LLC BBB Business Review"
                                src="https://p1.liveauctioneers.com/seals/blue-seal-250-52-bbb-123530.png"
                                style={{ height: '52px', width: '250px' }}
                            />
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default React.memo(Trust);
